import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';

/** Representa o Filter da entidade GrupoClassificacao */
export class GrupoClassificacaoFilter implements Filter {
    isFilterDirty = false;

    filterPsq: string;
    situacao: number;
    situacoes: number[] = [];
    idsTiposClassificacoes: number[] = [];
    tipoClassificacaoNull = false;
    idsClassificacoes: number[] = [];
    classificacaoNull = false;

    // Configurações
    considerarClienteAnaliseMercado: boolean = null;
    considerarMeta: boolean = null;

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }

        // Situações
        this.situacoes?.forEach(situacao => params = params.append('situacao', situacao.toString()));
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }

        // Tipos de classificaçãos
        this.idsTiposClassificacoes?.forEach(idTipoClassificacao => {
            if (idTipoClassificacao > 0) {
                params = params.append('idTipoClassificacao', idTipoClassificacao.toString());
            }
        });
        // Sem tipo de classificação
        if (this.tipoClassificacaoNull) {
            params = params.append('tipoClassificacaoNull', 'true');
        }

        // Classificações de itens
        this.idsClassificacoes?.forEach(idClassificacao => {
            if (idClassificacao > 0) {
                params = params.append('idClassificacao', idClassificacao.toString());
            }
        });
        // Sem classificação
        if (this.classificacaoNull) {
            params = params.append('classificacaoNull', 'true');
        }

        // Considerar Cliente Análise Mercado
        if (this.considerarClienteAnaliseMercado != null && this.considerarClienteAnaliseMercado !== undefined) {
            params = params.append('considerarClienteAnaliseMercado', this.considerarClienteAnaliseMercado.toString());
        }

        // Considerar Meta
        if (this.considerarMeta != null && this.considerarMeta !== undefined) {
            params = params.append('considerarMeta', this.considerarMeta.toString());
        }

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.filterPsq = null;
        this.situacoes = [];
        this.situacao = null;
        this.idsTiposClassificacoes = [];
        this.tipoClassificacaoNull = false;
        this.idsClassificacoes = [];
        this.classificacaoNull = false;

        // Configurações
        this.considerarClienteAnaliseMercado = null;
        this.considerarMeta = null;
    }
}

